import React, { useEffect } from "react";
import Blocks from "../components/Blocks";
import Footer from "../components/Footer";
import SEO from "../utils/SEO";
import Header from "../components/Header";
import CareerBlock from "../components/CareerBlock/CareerBlock";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

function Page(props) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <div className={"page " + props.page.slug}>
        <SEO
          title={props.page.pageTitleSEO}
          description={props.page.pageDescriptionSEO}
          indexStatus={props.page.hideFromSiteMap}
        />
        <Header />

        <Blocks pageData={props.page.pageBlocks} maps={props.maps} />
        {props.page.slug === "careers" ? (
          <CareerBlock data={props.careers} />
        ) : (
          ""
        )}
      </div>
      <Footer footerData={props.footerData} />
    </>
  );
}
Page.propTypes = {
  page: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    pageTitleSEO: PropTypes.string,
    pageDescriptionSEO: PropTypes.string,
    hideFromSiteMap: PropTypes.bool,
    pageBlocks: PropTypes.array.isRequired,
  }).isRequired,
  maps: PropTypes.object,
  careers: PropTypes.array,
  footerData: PropTypes.object.isRequired,
};
export default Page;
